import React from 'react';
import { motion } from 'framer-motion';
import { Bus, Car, Bike, Footprints, CheckCircle2, CarTaxiFront } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
import { TransportOption as TransportType } from '../utils/mockData';
interface TransportOptionProps {
  option: TransportType;
  selected: boolean;
  onSelect: () => void;
}
const icons = {
  Bus: Bus,
  Car: Car,
  Bike: Bike,
  Footprints: Footprints,
  CarTaxiFront: CarTaxiFront
};
export function TransportOption({
  option,
  selected,
  onSelect
}: TransportOptionProps) {
  const Icon = icons[option.icon as keyof typeof icons] || Bus;
  return <motion.div whileTap={{
    scale: 0.98
  }} onClick={onSelect} className={`relative p-4 rounded-xl border-2 transition-all cursor-pointer ${selected ? 'border-[#006a4e] bg-[#006a4e]/5' : 'border-gray-100 bg-white hover:border-gray-200'}`} data-id="element-141">
      <div className="flex items-center justify-between" data-id="element-142">
        <div className="flex items-center space-x-4" data-id="element-143">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${selected ? 'bg-[#006a4e]/20 text-[#006a4e]' : 'bg-gray-100 text-gray-500'}`} data-id="element-144">
            <Icon size={24} data-id="element-145" />
          </div>
          <div data-id="element-146">
            <h3 className="font-bold text-gray-900 font-bengali text-lg" data-id="element-147">
              {option.name}
            </h3>
            <p className="text-sm text-gray-500 font-bengali" data-id="element-148">{option.note}</p>
          </div>
        </div>

        <div className="text-right" data-id="element-149">
          <p className="font-bold text-gray-900 font-bengali text-lg" data-id="element-150">
            {option.fareRange[0] > 0 ? `৳${toBengaliNumeral(option.fareRange[0])}` : 'ফ্রি'}
          </p>
          <p className="text-xs text-gray-500 font-bengali" data-id="element-151">
            ~{toBengaliNumeral(option.durationMinutes)} মি
          </p>
        </div>
      </div>

      {selected && <div className="absolute -top-2 -right-2 bg-[#006a4e] text-white rounded-full p-1" data-id="element-152">
          <CheckCircle2 size={16} data-id="element-153" />
        </div>}
    </motion.div>;
}